import React from "react";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import "./style.scss";

function Pppj() {
  useDocumentTitle("Pajak PPJ- BAPENDA BEKASI");
  return (
    <div className="page">
      <Header active="Pppj" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Jenis Pelayanan / Pajak PPJ" />
          <div className="page-title-wrapper">
            <div className="page-title">PBJT ATAS TENAGA LISTRIK</div>
          </div>

          {/* <p className="page-text">
          </p> */}

          <p className="subpage-title"><strong>PBJT Atas Tenaga Listrik</strong></p>
          <p className="page-text">Tenaga Listrik adalah tenaga atau energi yang dihasilkan oleh suatu
pembangkit tenaga listrik yang didistribusikan untuk bermacam peralatan
listrik.Jasa tenaga listrik termasuk dalam jenis Pajak Barang dan Jasa Tertentu yang selanjutnya disingkat PBJT adalah Pajak yang dibayarkan oleh konsumen akhir atas konsumsi barang dan/atau jasa tertentu. Barang dan Jasa Tertentu adalah barang dan jasa tertentu yang dijual
dan/atau diserahkan kepada konsumen akhir.
</p>
<p className="page-text"><strong> Konsumsi Tenaga Listrik yang menjadi Objek PBJT Tenaga Listrik
adalah penggunaan Tenaga Listrik oleh pengguna akhir.</strong><br></br>
</p>

<p className="page-text"><strong>
Dasar pengenaan PBJT adalah jumlah yang dibayarkan oleh konsumen
barang atau jasa tertentu, meliputi:</strong> <br></br>
A. nilai jual Tenaga Listrik untuk PBJT atas Tenaga Listrik;<br></br>
B. Nilai jual tenaga listrik sebagaimana dimaksud dalam huruf A ditetapkan untuk:<br></br>
1. Tenaga Listrik yang berasal dari sumber lain dengan pembayaran; dan<br></br>
2. Tenaga Listrik yang dihasilkan sendiri<br></br>
C. Nilai jual Tenaga Listrik yang ditetapkan untuk tenaga listrik yang berasal
dari sumber lain dengan pembayaran dihitung berdasarkan:<br></br>
1. jumlah tagihan biaya/beban tetap ditambah dengan biaya pemakaian
kWh/variabel yang ditagihkan dalam rekening listrik, untuk pascabayar;
dan<br></br>
2. jumlah pembelian Tenaga Listrik untuk prabayar<br></br>
D. Nilai jual Tenaga Listrik yang ditetapkan untuk Tenaga Listrik yang
dihasilkan sendiri dihitung berdasarkan:<br></br>
1. kapasitas tersedia;<br></br>
2. tingkat penggunaan listrik;<br></br>
3. jangka waktu pemakaian listrik; dan<br></br>
4. harga satuan listrik yang berlaku di wilayah Daerah.<br></br>
E. Nilai jual Tenaga Listrik yang ditetapkan untuk Tenaga Listrik yang berasal
dari sumber lain dengan pembayaran, penyedia
Tenaga Listrik sebagai Wajib Pajak melakukan penghitungan dan
Pemungutan PBJT atas Tenaga Listrik untuk penggunaan Tenaga Listrik
yang dijual atau diserahkan.<br></br>
</p>

<p className="page-text"><strong>Tarif PBJT Atas Tenaga Listrik Sebagai Berikut :</strong><br></br>
<strong>A. rumah tangga:</strong><br></br>
1. 3% (tiga persen) untuk pengguna 450 VA;<br></br>
2. 5% (lima persen) untuk pengguna 900 VA;<br></br>
3. 7% (tujuh persen) untuk pengguna 1.300 VA;<br></br>
4. 8% (delapan persen) untuk pengguna 2.200 VA;<br></br>
5. 8,5% (delapan koma lima persen) untuk pengguna 3.500 VA;<br></br>
6. 9% (sembilan persen) untuk pengguna 4.400 VA ke atas.<br></br>
<strong>B. bisnis:</strong><br></br>
1. 4% (empat persen) untuk pengguna 450 VA;<br></br>
2. 6% (enam persen) untuk pengguna 900 VA;<br></br>
3. 7,5% (tujuh koma lima persen) untuk pengguna 1.300 VA;<br></br>
4. 8,5% (delapan koma lima persen) untuk pengguna 2.200 VA;<br></br>
5. 9% (sembilan koma lima persen) untuk pengguna 3.500 VA;<br></br>
6. 9,5% (sembilan koma lima persen) untuk pengguna 4.400 VA ke atas.<br></br>
<strong>C. fasilitas sosial dan umum 3% (tiga persen) untuk sosial komersial.</strong><br></br>
<strong>D. 3% (tiga persen) untuk konsumsi Tenaga Listrik dari sumber lain oleh
industri, pertambangan minyak bumi dan gas alam;</strong><br></br>
<strong>E. 1,5% (satu koma lima persen) untuk konsumsi Tenaga Listrik yang
dihasilkan sendiri.</strong><br></br>
</p>

<br></br>
<p className="page-text"><strong>
DASAR HUKUM : </strong><br></br>
<a href="https://jdih.bekasikota.go.id/peraturan-daerah/view?id=525" target="_blank" rel="noreferrer"><font color="blue">Peraturan Daerah Kota Bekasi Nomor 1 Tahun 2024 Tentang Pajak Daerah Dan Retribusi Daerah</font></a>
</p>
        
         
         
          
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default Pppj;
